import { render, staticRenderFns } from "./IorderCheckoutModal.vue?vue&type=template&id=1fb4f544&scoped=true&"
import script from "./IorderCheckoutModal.vue?vue&type=script&lang=js&"
export * from "./IorderCheckoutModal.vue?vue&type=script&lang=js&"
import style0 from "./IorderCheckoutModal.vue?vue&type=style&index=0&id=1fb4f544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4f544",
  null
  
)

export default component.exports